import { RouteObject } from "react-router-dom";
import BillingSummary from "./components/BillCycleSummary";
import BillCycleDetail from "./components/landing/BillCycleDetail";
import CreateBillCycle from "./components/landing/CreateBillCycle";
import Landing from "./components/landing/landing";
export interface BillCycleRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BillCycleRoute[];
}
export const bxBillCycleRoutes: BillCycleRoute[] = [
  {
    path: "/bx/bill-setup/billcycle",
    element: <Landing />,
  },
  {
    path: "/bx/bill-setup/billcycle/detail/:id",
    element: <BillCycleDetail />,
  },
  {
    path: "/bx/bill-setup/billcycle/action/:action",
    element: <CreateBillCycle />,
  },
  {
    path: "/bx/bill-setup/billcycle/action/:action/:id",
    element: <CreateBillCycle />,
  },
  {
    path: "/bx/bill-setup/billcycle/summary/:id",
    element: <BillingSummary />,
  },
];
